import { ParsedWPBlock } from "@/src/types/Embeds";
import { Tweet } from "react-tweet";

const TwitterBlock = ({ block }: { block: ParsedWPBlock }) => {
  try {
    const url = JSON.parse(block.content ?? "")["url"];
    const id = url.split("/status/")[1];

    if (id) {
      return <Tweet id={id} />;
    } else {
      return (
        <div style={{ display: "flex", width: "100%" }}>
          <iframe
            width={550}
            src={`https://twitframe.com/show?${url}`}
          ></iframe>
        </div>
      );
    }
  } catch (e) {
    return <></>;
  }
};

export default TwitterBlock;
